import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Aviator Pro (Angular)',
    ModuleType: DwModuleType.application,
    ProductVersion: '1.2.439',
    PublishDateTime: '10/30/2026 04:42:37 PM'
}
